export const calculateTotalPages = (itemsPerPage: number, totalItems: number) =>
  totalItems > 0 ? Math.trunc((totalItems - 1) / itemsPerPage) + 1 : 1;
